<template>
  <div class="user-main-box">
    <user-header></user-header>
    <user-menu :status='1'></user-menu>
    <div class="user-contents-main-box">
      <div class="wrapper">
        <div class="grid1">
          <h2>1.茶葉を選ぶ ▶ 2.焙煎度合を選ぶ ▶ 3.内容量を選ぶ ▶ 4.数量を選ぶ</h2>
          <h3 class="item-box-title">１．ブレンドしたいお茶を選択してください。</h3>
          <h4>
            お好きな茶葉を２種類まで選択できます。<br />
            「本茶」とは、お茶の葉の部分。美味しさや成分がぎゅっと詰まっています。<br />
            「棒」とは、お茶の茎の部分。まろやかな旨味と爽やかな香りが特徴です。
          </h4>
          <div class="flax">
            <div class="item-box" v-for="(item, index) in items" :key="index">
              <div><img class="item-img" :src="img_src(item.src)"><p class="item-name">{{item.name}}</p></div>
              <div class="icon-box">
                <img v-for="(icon, index2) in item.icons" :key="index2" :src="icon_src[icon]" width="30" height="30">
              </div>
              <p class="about">{{item.about}}</p>
              <div class="check-box">
                <input :id="index" type="checkbox" v-model="pre_cart.item" :value="item.id" :change="item_select()">
                <label :for="index">ブレンドする</label>
              </div>
            </div>
          </div>

          <h3 class="item-box-title">２．焙煎を選択してください。</h3>
          <h4>
            普段飲む機会の多い浅煎り(冠せ茶)から、カフェインレスで飲みやすい深煎り(ほうじ茶)までの間で焙煎を選択できます。
          </h4>
          <div class="flax">
            <div class="item-box2" :class="`roasted-b-${index}`" v-for="(item, index) in roasteds" :key="index">
              <p class="item-roasted">{{item.roasted}}</p>
              <p class="item-name2" :class="`roasted-c-${index}`">{{item.name}}</p>
              <p class="item-scene">{{item.scene}}</p>
              <p class="about2">{{item.description}}</p>
              <div class="radio-box">
                <input :id="`roa_${index}`" type="radio" v-model="pre_cart.roasted" :value="item.id">
                <label :for="`roa_${index}`">選択する</label>
              </div>
            </div>
          </div>

          <div class="flax">
            <div class="sub-flex1">
              <h3 class="item-box-title">３．内容量を選択してください。</h3>
              <select v-model.number="pre_cart.weight">
                <option v-for="(weight, index) in weights" :key="index" :value="weight.value">{{weight.type}}</option>
              </select>
            </div>
            <div class="sub-flex2">
              <h3 class="item-box-title">４．数量を選択してください。</h3>
              <select v-model.number="pre_cart.num">
                <option v-for="(num, index) in 5" :key="index" :value="num">{{num}}個</option>
              </select>
            </div>
          </div>

        </div>
        <div class="grid2">
          <h3>カート</h3>
          <div class="cart-item" v-for="(cart, index) in carts" :key="index">
            <a class="item-del" @click="item_del(index)"><span class="del-icon"></span>削除する</a>
            <p v-for="(item, index2) in cart.item" :key="index2">・{{items_id_list[item].name}}</p>
            <p class="">{{roasted_text(cart.roasted)}} / {{cart.weight}}g × {{cart.num}}個</p>
            <p class="item-price">{{yen(cart.price)}}円</p>
          </div>
        </div>
        <div class="grid6">
          <h3>小計</h3>
            <button class="button" @click="cart_in()">カートに入れる</button>
            <p class="price">{{price}}円</p>
        </div>
        <div class="grid7">
          <h3>合計</h3>
          <div class="price-sub">
            <p class="price-about">商品合計：<label>{{total_price[0]}}円</label></p>
            <p class="price-about">税：<label>{{total_price[1]}}円</label></p>
            <p class="price-about">送料：<label>{{total_price[2]}}円</label></p>
            <p class="price-about" v-if="total_price[4] != 0">(あと{{total_price[4]}}円で送料無料)</p>
          </div>
          <p class="total_price"><label>{{total_price[3]}}円</label></p>
          <button class="button2 buy" @click="buy()">購入する</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import UserHeader from '@/views/components/user/UserHeader';
import UserMenu from '@/views/components/user/UserMenu';
export default {
  name: 'UserMain',
  // ===========================================================================
  // components
  // ===========================================================================
  components: {
    UserHeader,
    UserMenu,
  },
  // ===========================================================================
  // data
  // ===========================================================================
  data () {
    return {
      items: this.$store.getters['uItemList/items'],
      items_id_list: this.$store.getters['uItemList/items_id_list'],
      roasteds: this.$store.getters['uItemList/roasteds'],
      weights: [{'type': '50g', 'value': 50}, {'type': '100g', 'value': 100}],
      pre_cart: {'item': [], 'roasted': 0, 'weight': 50, 'weight_p': [], 'num': 1, 'price': 0},
      icon_src: ['', require('../../assets/nigami.svg'), require('../../assets/shibumi.svg'), require('../../assets/amami.svg'), require('../../assets/umami.svg')],
      carts: this.$store.getters['uCart/carts'],
      post_price: this.$store.getters['uMaster/post_price'],
      post_price_border: this.$store.getters['uMaster/post_price_border'],
      tax: this.$store.getters['uMaster/tax'],
    };
  },
  // ===========================================================================
  // computed
  // ===========================================================================
  computed: {
    price () {
      const item = this.pre_cart;
      let p = 0;
      const num = item.item.length;
      if (num === 0) {
        return p;
      }
      const w = item.weight / num;

      for (let i = 0; i < num; i++) {
        p += this.items_id_list[item.item[i]].unit_price * w;
      }

      p = p * item.num;
      item.price = p;
      return this.$lib._yen(p);
    },
    total_price () {
      let p = 0;
      let tax = 0;
      let post_price = 0;
      let post_limit = 0;
      let total = 0;
      const num = this.carts.length;
      for (let i = 0; i < num; i++) {
        p += this.carts[i].price;
      }
      tax = Math.floor(p * this.tax / 100);
      if (p != 0 && (p + tax) < this.post_price_border) {
        // 送料在り
        post_price = this.post_price;
        post_limit = this.post_price_border - p - tax;
      }
      total += p;
      total += tax;
      total += post_price;
      return [this.$lib._yen(p), this.$lib._yen(tax), this.$lib._yen(post_price), this.$lib._yen(total), this.$lib._yen(post_limit)];
    },

  },
  // ===========================================================================
  // created
  // ===========================================================================
  created () {
  },
  // ===========================================================================
  // mounted
  // ===========================================================================
  mounted () {
  },
  // ===========================================================================
  // destroyed
  // ===========================================================================
  destroyed () {
  },
  // ===========================================================================
  // methods
  // ===========================================================================
  methods: {
    item_select () {
      const item = this.pre_cart;
      const num = item.item.length;
      if (num > 2) {
        item.item.pop();
        this.$alert('alert', 'ブレンドできるお茶は２種類です。');
      }
    },
    cart_in () {
      if (this.price === 0) {
        this.$alert('alert', 'ブレンドするお茶を選択してください。');
        return;
      }
      if (this.pre_cart.roasted === 0) {
        this.$alert('alert', '焙煎を選択してください。');
        return;
      }
      // weight_p設定
      let wp = 100;
      const num = this.pre_cart.item.length;
      for (let i = 0; i < num; i++) {
        this.pre_cart.weight_p[i] = wp / num;
      }

      this.$store.commit('uCart/set_item', this.pre_cart);
      this.pre_cart = {'item': [], 'roasted': 0, 'weight': 50, 'weight_p': [], 'num': 1, 'price': 0};
    },
    yen (p) {
      return this.$lib._yen(p);
    },
    roasted_text (n) {
      const obj = this.roasteds.filter(function (item){
        if (item.id === n) return true;
      });
      return obj[0].roasted;
    },
    item_del (index) {
      this.$store.commit('uCart/del_item', index);
    },
    buy () {
      if (this.carts.length === 0) {
        this.$alert('alert', 'カートに商品が入っていません。\n商品を選択してください。');
        return;
      }
      this.$store.commit('uCart/set_price', this.total_price);
      this.$router.push({name: 'uSendEdit', query: {}});
      // onCreated_cb_set(this.buy_cb);
      // const tag = this.$lib._$id('payjp_checkout_box');
      // const evt = document.createEvent("MouseEvents");
      // evt.initMouseEvent("click", true, true, window, 0, 0, 0, 0, 0, false, false, false, false, 0, null);
      // tag.children[0].dispatchEvent( evt );
    },
    // buy_cb (res) {
    //   if (res.error) {
    //     this.$alert('alert', 'カード情報に謝りがあります。\n再度入力してください。');
    //     return;
    //   }
    //   let ld = new this.$loader(this);
    //   const total = this.total_price;
    //   ld._data_set({
    //     'card_token': res.id,
    //     'orders': this.carts,
    //     'post_price': total[2],
    //     'tax': total[1],
    //   });
    //   ld._post_cb_f = this.pay_check_cb;
    //   ld._load_start('/user/pay_check.php');
    // },
    // pay_check_cb (data) {
    //   // カートをリセット
    //   this.$store.commit('uCart/reset');

    //   this.$router.push({name: 'uPayFin', query: {'order_id': data.data.order_id}});
    // },
    img_src (src) {
      return require(`../../assets/item_img/${src}`);
    }
  },
  // ===========================================================================
  // watch
  // ===========================================================================
  watch: {
  },
};
</script>

<style lang="scss">
#payjp_checkout_box {
  display: none;
}
.user-main-box {
  background: #fefefe;
  .user-contents-main-box {
    padding: 20px;
    margin: 50px 0 0 224px;
    height: calc(100vh - 90px);
  }
  .wrapper {
    height: 100%;
    display: -ms-grid;
    display: grid;
    -ms-column-gap: 1em;
    -ms-row-gap: 1em;
    -ms-grid-columns: 1fr 300px 1fr 250px;
    -ms-grid-rows: 1fr 1fr 1fr 140px 132px;

    column-gap: 1em;
    row-gap: 1em;
    grid-template-columns: 1fr 300px 1fr 250px;
    grid-template-rows: 1fr 1fr 1fr 140px 112px;
    h2 {
      font-size: 16px;
      margin-bottom: 10px;
    }
    h3 {
      text-align: left;
      margin: 10px 0 0 20px;
      line-height: 1.6;
      font-size: 16px;
    }
    h4 {
      font-size: 14px;
      margin-top: 10px;
      color: #6e6b59;
      font-weight: 100;
    }
  }
  .grid1 {
    overflow-y: auto;
    -ms-grid-column: 1;
    -ms-grid-column-span: 3;
    -ms-grid-row: 1;
    -ms-grid-row-span: 4;

    grid-column: 1 / span 3;
    grid-row: 1 / span 4;
    background: #fefefe;
    .item-box-title {
      font-size: 22px;
      text-align: center;
      border-bottom: 4px solid #d4ff9d;
      padding: 0px 10px;
      margin: 0;
    }
    .flax {
      justify-content: center;
      display: flex;
      flex-wrap: wrap;
      padding: 0px 0 10px 0;;
      .item-box {
        width: 260px;
        min-width: 260px;
        height: 385px;
        background: #fefefe;
        margin: 10px;
        border: 4px solid #cecbc4;
      }
      .item-box2 {
        width: 240px;
        min-width: 220px;
        height: 232px;
        background: #fefefe;
        margin: 10px;
        border: 4px solid #cecbc4;
      }
      .roasted-b-0 {
        border: 4px solid #838b41;
      }
      .roasted-b-1 {
        border: 4px solid #8b7b0e;
      }
      .roasted-b-2 {
        border: 4px solid #bd7225;
      }
      .roasted-c-0 {
        color: #fefefe;
        background: #838b41;
      }
      .roasted-c-1 {
        background: #8b7b0e;
      }
      .roasted-c-2 {
        background: #bd7225;
      }
    }
    .sub-flex1 {
      flex: 1;
      padding-right: 10px;
      min-width: 290px;
    }
    .sub-flex2 {
      flex: 1;
      padding-left: 10px;
      min-width: 290px;
    }
  }
  .grid2 {
    overflow-y: auto;
    -ms-grid-column: 4;
    -ms-grid-column-span: 1;
    -ms-grid-row: 1;
    -ms-grid-row-span: 3;

    grid-column: 4 / span 1;
    grid-row: 1 / span 3;
    border: 4px solid #efa7b6;
    h3 {
      padding-left: 10px;
      border-left: 6px solid #df274c;
    }
  }
  .grid6 {
    -ms-grid-column: 1;
    -ms-grid-column-span: 3;
    -ms-grid-row: 5;
    -ms-grid-row-span: 1;

    grid-column: 1 / span 3;
    grid-row: 5 / span 1;
    border: 4px solid #efa7b6;
    h3 {
      padding-left: 10px;
      border-left: 6px solid #df274c;
    }
  }
  .grid7 {
    -ms-grid-column: 4;
    -ms-grid-column-span: 1;
    -ms-grid-row: 4;
    -ms-grid-row-span: 2;

    grid-column: 4 / span 1;
    grid-row: 4 / span 2;
    border: 4px solid #efa7b6;
    h3 {
      padding-left: 10px;
      border-left: 6px solid #df274c;
    }
  }
  .price-sub  {
    height: 84px;
  }
  .item-name {
    padding: 5px 0 4px 0;
    font-size: 15px;
    line-height: 14px;
    color: #fefefe;
    margin: 5px 40px 0px 40px;
    background: #1b2010;
    border-radius: 12px;
    position: relative;
    font-weight: 600;
  }
  .item-roasted {
    margin-top: 10px;
  }
  .item-name2 {
    padding: 5px 0 4px 0;
    font-size: 15px;
    line-height: 14px;
    color: #fefefe;
    margin: 3px 30px 5px 30px;
    background: #1b200e;
    border-radius: 12px;
    font-weight: 600;
  }
  .item-scene {
    font-size: 12px;
    color: #8e2a38;
    font-weight: 600;
  }
  .item-scene::before {
    content: '';
    width: 80px;
    height: 39px;
    background-image: url('../../assets/osusume.svg');
    background-repeat: no-repeat;
    display: block;
    margin: 0 auto;
  }
  .item-img {
    margin-top: 10px;
    width: 238px;
    height: 148px;
  }
  select {
    font-size: 18px;
    width: 120px;
    height: 44px;
    margin: 10px;
    cursor: pointer;
  }
  .about {
    text-align: left;
    padding: 10px;
    height: 70px;
    font-size: 12px;
    color: #5e5b47;
  }
  .about2 {
    text-align: left;
    padding: 10px;
    height: 55px;
    font-size: 12px;
    color: #5e5b47;
  }
  .check-box {
    padding: 15px 0 10px 0;
  }
  .radio-box {
    padding: 0px 0 10px 0;
  }
  .icon-box {
    padding: 12px 0 0 11px;
    text-align: left;
    img {
      margin-right: 5px;
    }
  }
  .price {
    width: 55%;
    text-align: right;
    font-size: 28px;
    margin: 10px 20px;
    font-weight: 600;
    border-bottom: 1px solid #666666;
  }
  .price-about {
    text-align: right;
    font-size: 14px;
    margin-right: 20px;
    label {
      width: 60px;
      display: inline-block;
    }
  }
  .button {
    float: right;
    margin: 0px 20px 20px 20px;
    height: 52px;
    width: 36%;
    border: none;
    border-radius: 6px;
    color: #fefefe;
    font-size: 16px;
    cursor: pointer;
  }
  .button2 {
    float: right;
    margin: 10px 20px 20px 20px;
    height: 62px;
    width: 36%;
    font-weight: 800;
    border: none;
    border-radius: 6px;
    color: #fefefe;
    font-size: 18px;
    cursor: pointer;
  }
  .cart-item {
    background: #fcf3f3;
    margin: 10px 10px 0 10px;
    padding: 5px;
    text-align: left;
    color: #1b2010;
    p {
      font-size: 14px;
    }
    .item-price {
      text-align: right;
      font-size: 16px;
      font-weight: 600;
    }
  }
  .item-del {
    font-size: 14px;
    float: right;
    text-decoration: underline;
    color: #da7d78;
    cursor: pointer;
    .del-icon {
      width: 11px;
      height: 11px;
      background-image: url('../../assets/punishment.svg');
      background-repeat: no-repeat;
      display: inline-block;
      margin: 0px 4px -1px 0;
    }
  }
  .total_price {
    width: calc(100% - 40px);
    text-align: right;
    font-size: 28px;
    margin: 5px 20px;
    font-weight: 600;
    border-bottom: 1px solid #666666;
  }
  .buy {
    width: calc(100% - 40px);
  }
  @media (max-width: 767px) {
    .user-contents-main-box {
      padding: 20px;
      margin: 50px 0 0 0;
      height: calc(100vh - 90px);
    }
    .wrapper {
      grid-template-columns: auto;
      grid-template-rows: auto 1fr 1fr 1fr 1fr 500px 1fr;
      .grid1 {
        grid-column: 1 / 2;
        grid-row: 1 / 2;
        height: max-content !important;
        .sub-flex1 {
          padding-right: 0px;
        }
        .sub-flex2 {
          padding-left: 0px;
        }
      }
      .grid2 {
        overflow-y: auto;
        grid-column: 1 / 2;
        grid-row: 6 / 7;
      }
      .grid6 {
        grid-column: 1 / 2;
        grid-row: 5 / 6;
        position: sticky;
        bottom: 20px;
        background: #fefefe;
      }
      .grid7 {
        grid-column: 1 / 2;
        grid-row: 7 / 8;
      }
    }
  }
}
</style>
